module.exports = __webpack_public_path__ + "assets/f1324d8e1ddc10d69f08824e3212b200.png";